'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Button } from '@/app/components/button';
import { IconChevronLeft } from '@/app/components/icons/ui-actions/icon-chevron-left';
import { IconClose } from '@/app/components/icons/ui-actions/icon-close';
import { ContainerStyled } from '@/app/components/layouts/container';
import { TopNavigationLogo } from '@/app/components/layouts/top-navigation/shared/logo';
import { TOP_NAV_DATA_GA } from '@/app/components/layouts/top-navigation/tracking';
import { TOP_NAV_HEIGHT_CLASSNAME, TOP_NAV_Z_CLASSNAME } from '@/app/constants/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataGA } from '@/app/utils/createDataGA';
interface MobileTopBarProps {
  logo?: ReactNode;
  className?: string;
  activeLabel?: string;
  onBack: () => void;
  onClose: () => void;
}
export const MobileTopBar = t0 => {
  const $ = _c(14);
  const {
    logo,
    className,
    activeLabel,
    onBack,
    onClose
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative flex items-center justify-between gap-x-2 border-b border-gray-50 bg-white", TOP_NAV_Z_CLASSNAME, TOP_NAV_HEIGHT_CLASSNAME, ContainerStyled({
      size: "mobile-only",
      maxWidth: "none"
    }), className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeLabel || $[3] !== logo || $[4] !== onBack) {
    t2 = !!activeLabel ? <Button variant="tertiary" color="red" size="sm" width="auto" iconBefore={<IconChevronLeft />} className="pl-0 text-left" onClick={onBack} {...createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.topNavigation,
      text: "Mobile menu back"
    })}>{activeLabel}</Button> : !!logo && <TopNavigationLogo logo={logo} />;
    $[2] = activeLabel;
    $[3] = logo;
    $[4] = onBack;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconClose />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataGA({
      click: true,
      eventName: TOP_NAV_DATA_GA.topNavigation,
      text: "Mobile menu close"
    });
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClose) {
    t5 = <Button variant="tertiary" color="black" iconBefore={t3} onClick={onClose} {...t4} className="shrink-0" />;
    $[8] = onClose;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t5) {
    t6 = <nav className={t1}>{t2}{t5}</nav>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};